module.exports = __webpack_public_path__ + "img/htm.72032d75.svg";